import { App } from 'vue';
import { Uploader } from 'vant';
import 'vant/lib/index.css';

const components = [Uploader];

export function bootVant({ app }: { app: App }) {
  for (const component of components) {
    app.use(component);
  }
}
